import React, { useState, useEffect, useRef } from 'react'
import HStack from './HStack'
import VStack from './VStack'
import RStack from './RStack'
import Data from './data/Data'


const theme = Data.theme

const componentStyles = {
    small: {
        holder: {
            root: {
                justifyContent: 'space-around', 
                flexWrap: 'wrap', 
                padding: '20px 0'
            }
        },
        container: {
            root: {
                margin: '20px',
                background: 'white',
                borderRadius: 10,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                border: 'solid 1px #eee'
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: 20,
                background: '#fbfbfb',
                borderRadius: 10
            }
        },
        imageContainer: {
            root: {
                padding: '0',
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    medium: {
        holder: {
            root: {
                justifyContent: 'space-around', 
                flexWrap: 'wrap', 
                padding: '20px 0'
            }
        },
        container: {
            root: {
                margin: 20,
                minWidth: 250,
                maxWidth: 300,
                background: 'white',
                borderRadius: 10,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                border: 'solid 1px #eee'
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: 20,
                background: '#fbfbfb',
                borderRadius: 10
            }
        },
        imageContainer: {
            root: {
                padding: '0',
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    large: {
        holder: {
            root: {
                justifyContent: 'space-around', 
                flexWrap: 'wrap', 
                padding: '20px 0',
                maxWidth: 1500,
                margin: '0 auto'
            }
        },
        container: {
            root: {
                margin: 20,
                minWidth: 250,
                maxWidth: 350,
                background: 'white',
                borderRadius: 10,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                border: 'solid 1px #eee'
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: 20,
                background: '#fbfbfb',
                borderRadius: 10
            }
        },
        imageContainer: {
            root: {
                padding: '0',
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    }
}

export default function Treatments(props) {
    const {
        size = 'large',
    } = props

    const cStyles = componentStyles[size] ?? {}

    return (
        <>
            {/* <VStack styles={{ root: { padding: 0, fontSize: 36, fontWeight: 500, alignSelf: 'center', color: theme.colours.text } }}>
            Treatments
            </VStack> */}
            <RStack size={size} styles={cStyles.holder}>
                {getTreatments()}
            </RStack>
        </>
    )

    function getTreatments() {
        const items = Data.treatmentData.map((t,idx) => {
            return (
                <VStack grow={1} key={idx} styles={cStyles.container}>
                    <VStack styles={cStyles.imageContainer}>
                        <img src={t.image} alt='doctor3' style={{ objectFit: 'cover', background: 'white', opacity: '0.9', borderRadius: '10px 10px 0 0', width: '100%' }} />
                    </VStack>
                    <VStack grow={1} styles={cStyles.textContainer}>
                        <VStack styles={cStyles.headerText}>
                            {t.main}
                        </VStack>
                        <VStack grow={1} styles={cStyles.detailText}>
                            {t.sub}
                        </VStack>
                    </VStack>
                </VStack>
            )
        })

        return items
    }
}